import { commonText } from 'constants/commonConstants';

export namespace AdminCounselerListConstants {
    export const pageCommonConstants = {
        title: '상담사 관리',
    };

    export const paginationHeaderConstants = {
        numbering: 'No.',
        hospitalName: commonText.hospitalName,
        email: '가입 아이디',
        userName: commonText.name,
        phoneNumber: commonText.phoneNumber,
        schedule: ''
    };
}
